import React, {useState, useEffect} from 'react';
import logo from '../img/logo_nuovo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faFacebook, faTelegram, faInstagram } from '@fortawesome/free-brands-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Image } from 'react-bootstrap';
import YTconfig from "./YTconfig.js"
import INSTAconfig from "./INSTAconfig.js"
import TGconfig from "./TGconfig.js"
import TG2config from "./TG2config.js"

export default function Filosofi() {
    
    const [subscribers, setSubscribers] = useState(0)
    const [followers, setFollowers] = useState(0)
    const [members, setMembers] = useState(0)
    const [members2, setMembers2] = useState(0)

    useEffect(() => {
        const { api_key , channel_id } = YTconfig
        const yt_api_call = "https://www.googleapis.com/youtube/v3/channels?part=statistics&id="+channel_id+"&key="+api_key
        fetch(yt_api_call)
        .then(result => result.json())
        .then(data => setSubscribers(data.items[0].statistics.subscriberCount))
        .catch(error => console.log(error))

        const { insta_api_call } = INSTAconfig
        fetch(insta_api_call)
        .then(result => result.json())
        .then(data => setFollowers(data.followers_count))
        .catch(error => console.log(error))

        const { tg2_api_call } = TG2config
        fetch(tg2_api_call)
        .then(result => result.json())
        .then(data => setMembers2(data.result))
        .catch(error => console.log(error))

        const { tg_api_call } = TGconfig
        fetch(tg_api_call)
        .then(result => result.json())
        .then(data => setMembers(data.result))
        .catch(error => console.log(error))
    })
    return (
        <div className='navIntro'>
            <span className="avatar"><Image src={logo} className="App-logo" roundedCircle /></span>
            
            <div class="row" style={{justifyContent:"center"}}>
            <p style={{fontWeight: 400}} class="accedi" >filosofinerba.it</p>
                <p  class="accedi" style={{fontWeight: 80, fontSize: "80%"}}> BETA</p>
            </div>
            
            <div class="row" style={{justifyContent: "center"}}>
                <a class="youtube social" href="https://www.youtube.com/c/filosofi_in_erba" target="_blank">
                    <FontAwesomeIcon icon={faYoutube} style={{fontSize:"25px"}} />
                    <text className="accedi">{subscribers}</text>
                </a>
                <a class="instagram social" href="https://www.instagram.com/filosofi_in_erba/" target="_blank">
                    <FontAwesomeIcon icon={faInstagram} style={{fontSize:"25px"}} />
                    <text className="accedi" >20003</text>
                </a>
                <a class="instagram social" href="https://www.instagram.com/filosofi.in.erba.cbd/" target="_blank">
                    <FontAwesomeIcon icon={faInstagram} style={{fontSize:"25px"}} />
                    <text className="accedi" >1471</text>
                </a>
                <a class="telegram social" href="https://t.me/filosofi_in_erba" target="_blank">
                    <FontAwesomeIcon icon={faTelegram} style={{fontSize:"25px"}} />
                    <text className="accedi">{members2}</text>
                </a>
                <a class="telegram social" href="https://t.me/GrowersinErba" target="_blank">
                    <FontAwesomeIcon icon={faTelegram} style={{fontSize:"25px"}} />
                    <text className="accedi"  >{members}</text>
                </a>
                <a class="facebook social" href="https://www.facebook.com/Filosofi-in-erba-20-112849270293339" target="_blank" >
                    <FontAwesomeIcon icon={faFacebook} style={{fontSize:"25px"}} />
                    <text className="accedi" >39</text>
                </a>
            </div>
        </div>
    );
}